import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class SellerChargesInvoiceService {

    constructor(private _http: HttpClient) { }

    invoicerecords(data) {
        return this._http.post(environment.api_url + 'seller/report/chargeinvoice', data);
    }

    subsellerinvoice(data) {
        return this._http.post(environment.api_url + 'seller/report/subsellerchargeinvoice', data);
    }

    generatechargesinvoice(data) {
        return this._http.post(environment.api_url + 'seller/chargeinvoice/generate', data);
    }

    subsellergeneratechargesinvoice(data) {
        return this._http.post(environment.api_url + 'subseller/chargeinvoice/generate', data);
    }

}